export default __webpack_public_path__ + "static/KODIT-6331b675171b7494ff760218279a4202.jpg";